import {
  updateBatchInput as requestUpdateBatchInput,
  createBatchInput as requestCreateBatchInput
} from "@utils/aegean_api_handler";

export const CREATE_INPUT_FILE_REQUEST = "CREATE_INPUT_FILE_REQUEST";
export const CREATE_INPUT_FILE_SUCCESS = "CREATE_INPUT_FILE_SUCCESS";
export const CREATE_INPUT_FILE_ERROR = "CREATE_INPUT_FILE_ERROR";

export const UPDATE_INPUT_FILE_REQUEST = "UPDATE_INPUT_FILE_REQUEST";
export const UPDATE_INPUT_FILE_SUCCESS = "UPDATE_INPUT_FILE_SUCCESS";
export const UPDATE_INPUT_FILE_ERROR = "UPDATE_INPUT_FILE_ERROR";

export const createBatchInput = inputData => (dispatch) => {
  dispatch({
    type: CREATE_INPUT_FILE_REQUEST,
    workspace_id: inputData.workspace_id
  });

  return requestCreateBatchInput(inputData)
    .then((result) => {
      dispatch({
        type: CREATE_INPUT_FILE_SUCCESS,
        data: result
      });
    })
    .catch((error) => {
      dispatch({
        type: CREATE_INPUT_FILE_ERROR,
        workspace_id: inputData.workspace_id,
        error
      });
    });
};

export const updateBatchInput = (id, inputData) => (dispatch) => {
  dispatch({
    type: UPDATE_INPUT_FILE_REQUEST,
    workspace_id: inputData.workspace_id
  });

  return requestUpdateBatchInput(id, inputData)
    .then((result) => {
      dispatch({
        type: UPDATE_INPUT_FILE_SUCCESS,
        data: result
      });
    })
    .catch((error) => {
      dispatch({
        type: UPDATE_INPUT_FILE_ERROR,
        workspace_id: inputData.workspace_id,
        error
      });
    });
};
